import { render, staticRenderFns } from "./lossCurve.vue?vue&type=template&id=15c58dcc&scoped=true&"
import script from "./lossCurve.vue?vue&type=script&lang=js&"
export * from "./lossCurve.vue?vue&type=script&lang=js&"
import style0 from "./lossCurve.vue?vue&type=style&index=0&id=15c58dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c58dcc",
  null
  
)

export default component.exports